export const mobileSurfaceClass =
  "rounded-2xl border border-border/60 bg-card p-4 shadow-sm";

